import React, {Component} from 'react';
import styles from './GalleryViewerItem.css';
import PropTypes from "prop-types"
import {TypeImage} from "../../constants/consts-prop-types"
import {loadImage} from "../../services/service-image-loader"
import {Map} from 'react-leaflet'
import IIIFTileLayer from 'react-leaflet-iiif'
import 'leaflet'
import Svg from "../Svg/Svg"
import {Icon} from "../../constants/consts-types"

class GalleryViewerItem extends Component {
  static propTypes = {
    index: PropTypes.number.isRequired,
    data: TypeImage.isRequired,
    numInview: PropTypes.number.isRequired,
    inView: PropTypes.bool.isRequired,
  }

  constructor(props) {
    super(props)

    this.exitHandler = this.exitHandler.bind(this)
    this.goFullscreen = this.goFullscreen.bind(this)
    this.exitFullscreen = this.exitFullscreen.bind(this)

    this.state = {
      imageSrc: null,
      x: 0,
      y: 0,
      zoom: 0,
      isFullscreen: false
    }

    this.itemWidth = 100 / 14 * 13 / this.props.numInview
  }

  componentDidMount() {
    loadImage(this.props.data.image_url, this)

    // trigger resize if IIIF (for proper centering & scaling of image):
    if(this.props.data.iiif_url) {
      try {
        window.dispatchEvent(new Event('resize'))
      } catch(e) {
        console.log('dispatchEvent error', e)
      }
    }
  }

  componentDidUpdate(prevProps) {
    if(this.props.data.image_url !== prevProps.data.image_url) {
      loadImage(this.props.data.image_url, this)
    }
  }

  exitHandler(event) {
    this.setState({
      isFullscreen: false
    })
  }

  removeFullscreenListeners() {
    document.removeEventListener('webkitfullscreenchange', this.exitHandler, false)
    document.removeEventListener('mozfullscreenchange', this.exitHandler, false)
    document.removeEventListener('fullscreenchange', this.exitHandler, false)
    document.removeEventListener('MSFullscreenChange', this.exitHandler, false)
  }

  goFullscreen() {
    this.removeFullscreenListeners()

    const elem = this.mapContainer

    if(elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if(elem.mozRequestFullScreen) { /* Firefox */
      elem.mozRequestFullScreen();
    } else if(elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
      elem.webkitRequestFullscreen();
    } else if(elem.msRequestFullscreen) { /* IE/Edge */
      elem.msRequestFullscreen();
    }

    this.setState({
      isFullscreen: true
    }, () => {
      setTimeout(() => {
        document.addEventListener('webkitfullscreenchange', this.exitHandler, false)
        document.addEventListener('mozfullscreenchange', this.exitHandler, false)
        document.addEventListener('fullscreenchange', this.exitHandler, false)
        document.addEventListener('MSFullscreenChange', this.exitHandler, false)
      }, 500)
    })
  }

  exitFullscreen() {
    this.removeFullscreenListeners()

    if(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement) {
      if(document.exitFullscreen) {
        document.exitFullscreen()
      } else if(document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if(document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      } else if(document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }

    this.setState({
      isFullscreen: false
    })
  }

  render() {
    const {inView} = this.props
    const {caption, iiif_url, iiif_manifest, image_full} = this.props.data
    const {
      imageSrc,
      isFullscreen,
      x,
      y,
      zoom
    } = this.state

    const stylesSliderItem = {
      width: `${this.itemWidth}vw`
    }

    return (
      <div className={inView ? styles.GalleryViewerItemInView : styles.GalleryViewerItem} style={stylesSliderItem}>
        <figure className={styles.figure}>

          {!iiif_url &&
          <div
            className={styles.image}
            style={{backgroundImage: `url(${imageSrc})`}}
          />
          }


          {iiif_url &&
          <div
            ref={node => this.mapContainer = node}
            className={styles.mapContainer}
          >
            <button
              className={styles.buttonFullscreen}
              onClick={() => isFullscreen ? this.exitFullscreen() : this.goFullscreen()}
            >
              {isFullscreen ? <Svg id={Icon.FULLSCREEN_EXIT}/> : <Svg id={Icon.FULLSCREEN}/>}
            </button>

            <Map
              center={[x, y]}
              crs={window.L.CRS.Simple}
              zoom={zoom}
              attributionControl={false}
            >
              <IIIFTileLayer
                attribution=''
                url={iiif_url}
              />
            </Map>

          </div>
          }


          <div className="row" style={{width: '100%'}}>
            <div className="col-xs-12 col-sm-8 col-md-6 col-lg-4">

              <div className={styles.iiifLinksWrapper}>
                {iiif_manifest &&
                <a href={iiif_manifest} target='_blank' className={styles.iiiflink}>
                  <img src='/static/images/logo-iiif.png' alt='IIIF Manifest'/>
                  <small>IIIF Manifest</small>
                </a>
                }
                {image_full &&
                <a href={image_full} className={styles.iiiflink} download>
                  <Svg id={Icon.DOWNLOAD}/>
                  <small style={{marginLeft: '.5rem'}}>Download</small>
                </a>
                }
              </div>

              <figcaption
                className={styles.caption}
                dangerouslySetInnerHTML={{__html: caption}}
              />
            </div>
          </div>
        </figure>
      </div>
    );
  }
}

export default GalleryViewerItem;



// WEBPACK FOOTER //
// ./src/components/GalleryViewerItem/GalleryViewerItem.js